import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { useIntegrationUsage } from '../lib/audit-feed';
import { AuditFeedList } from './AuditFeedList';
import { Panel } from './Panel';
import { QueryBoundary } from './QueryBoundary';

// #1222: connections-view usage feed. One Panel under the catalog grid that
// shows the account's recent `integration.used` audit rows. Reuses
// `<AuditFeedList>` verbatim — the row shape is identical to the account
// audit feed (#854). The audit gate is enforced server-side (accountId
// tenant fence in `listRecentAuditByAccount`); this view only renders what's
// already authorised.
//
// THROUGH `<QueryBoundary/>`, not a ladder of `<Show>`s. The hand-rolled version
// picked its own branches — `isError` → `<ErrorState onRetry/>` — so a 403 never
// reached `isForbidden` and the panel offered a Try again that could only 403
// again, for ever — one of the two sites `src/testing/axe-routes.test.tsx`
// found once it started sweeping all 42 routes in a denied state.
// The boundary also owns the sr-only loading announcement this panel never had.

export function IntegrationUsage(props: { readonly token: string | null }): JSX.Element {
  const query = useIntegrationUsage(() => null, props.token);
  return (
    <Panel title={t('integrations.usage.title')} class="integrations-usage">
      <QueryBoundary
        query={query}
        isEmpty={(page) => page.data.length === 0}
        loading={<p class="list-empty">{t('integrations.usage.loading')}</p>}
        empty={<p class="list-empty">{t('integrations.usage.empty')}</p>}
      >
        {(page) => <AuditFeedList events={page.data} />}
      </QueryBoundary>
    </Panel>
  );
}
